import { Box, styled, Typography } from "@mui/material";
import AuthImageIcon from "../../../assets/images/img-login.png";

export const StyledBoxImage = styled(Box)(() => ({
  minHeight: "100vh",
  height: "100%",

  width: "100%",
  padding: "23px",
}));

export const StyledBoxHeight = styled(Box)({
  minHeight: "calc(100vh - 46px)",
  height: "100%",
  position: "relative",
});
export const StyledImage = styled(Box)(({ theme }) => ({
  backgroundImage: `url(${AuthImageIcon})`,
  backgroundSize: "cover",
  backgroundPosition: "top center",
  width: "100%",
  height: "100%",
  alignItems: "flex-end",
  borderRadius: theme.borderRadius.radius.large,
}));

const ClashDisplayFont = `
  @font-face {
    font-family: "Clash Display";
    src: url("/fonts/ClashDisplay-Regular.woff2") format("woff2");
    font-weight: normal;
    font-style: normal;
  }
`;

export const StyledHeading = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography?.toLargeText?.fontSize,
  fontWeight: theme.typography.fontWeight.medium,
  color: theme.palette.custom.imageColor,
  position: "absolute",
  left: "54px",
  bottom: "54px",
  lineHeight: 1,

  fontFamily: '"Clash Display", sans-serif  !important',

  [theme.breakpoints.down("sm")]: {
    fontSize: theme.typography["3xl"].fontSize,
  },
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));
export const StyledSpan = styled("span")(({ theme }) => ({
  color: theme.palette.custom.white,
}));

const styleTag = document.createElement("style");
styleTag.innerHTML = ClashDisplayFont;
document.head.appendChild(styleTag);
